export * from './lib/footer.module';
